// JavaScript Document
//components/signs/category/Table.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';

const useStyles = makeStyles({
  table: {
	maxHeight:'calc(100vh - 84px)',
	  flexGrow: 1,
	//maxHeight: '100%'
  },
	datecol : {
		minWidth: 100
	}

});


export default function HistoryTable(props) {
	const classes = useStyles();
	const {items} = props;

  return (
    <TableContainer component={Paper} className={classes.table}>
      <Table stickyHeader aria-label="sign categories">
        <TableHead>
          <TableRow>
	  		<TableCell>Date</TableCell>
            <TableCell>User</TableCell>
            <TableCell>Changes</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((row) => (
            <TableRow hover role="checkbox" key={row.id}>
              <TableCell component="th" scope="row" className={classes.datecol}>
                {moment(row.log_date).fromNow()}
              </TableCell>
	  			<TableCell>{row.user_name}</TableCell>
	  			<TableCell><div dangerouslySetInnerHTML={{__html:row.description}}></div></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
